import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import ConfirmationModal from "../../../../Shared/ConfimationModal";

function UserDeleteBtn({ user, handleModalDelete }) {
  const [removeUserIsOpen, setRemoveUserIsOpen] = useState({
    open: false,
    content: "",
  });

  return (
    <span>
      <IconButton
        value={user}
        data-testid="delete_user_btn"
        onClick={(event) => {
          setRemoveUserIsOpen({
            open: true,
            content: "Are you sure you want to delete this user?",
          });
        }}
      >
        <Close />
      </IconButton>
      {removeUserIsOpen.open && (
        <ConfirmationModal
          open={removeUserIsOpen.open}
          content={removeUserIsOpen.content}
          deleteHandler={() => {
            handleModalDelete(user);
          }}
          setIsopen={setRemoveUserIsOpen}
        />
      )}
    </span>
  );
}

export default UserDeleteBtn;
